import { render } from "./vendor_credits.vue?vue&type=template&id=8c2fb204"
import script from "./vendor_credits.vue?vue&type=script&lang=js"
export * from "./vendor_credits.vue?vue&type=script&lang=js"

import "./vendor_credits.vue?vue&type=style&index=0&id=8c2fb204&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__